/* eslint-disable arrow-parens */
import { useState, useCallback, useEffect, useContext, useRef, Suspense, KeyboardEvent } from "react";
import { useNavigate } from "react-router-dom";
import { useDebouncedCallback } from "use-debounce";
import { Paper, Select, MenuItem, Grid, Button, TextField, InputAdornment, Tooltip } from "@material-ui/core";
import { withStyles, Theme } from "@material-ui/core/styles";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../../../constants/caption/dashboardHeader";
import { AuthContext, UIContext } from "../../../../../../../contexts";
import GENDERS from "../../../../../../../constants/genders";
import { MARITAL_STATUSES } from "../../../../../../../constants/maritalStatus";
import initCapitalize from "../../../../../../../utils/commonFunctions/initCapitalize";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import "date-fns";
import { DynamicForm } from "../../../../../../../@types/dynamicForm.types";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { MemberTypes } from "../../../../../../../@types/components/member.types";
import useRouteParam from "../../../../../../../hooks/useRouteParam";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../../../../../utils/api";
import ROLES from "../../../../../../../constants/roles";

import SendIcon from "@material-ui/icons/Send";
import ReplyIcon from "@material-ui/icons/Reply";
import EventIcon from "@material-ui/icons/Event";
import InfoIcon from "@material-ui/icons/Info";
import { infoTitleMessage } from "../../../../../../../constants/infoTitleMessage";
import { ConditionPosition } from "ag-grid-community/dist/lib/filter/provided/simpleFilter";
import { Validation } from "../../../../../../../@types/validation.types";
import { LazySnackbarAPI } from "../../../../../../shared";
import ExtractRouteParams from "../../../../../../../utils/commonFunctions/extractRouteParams";
import SnackbarAPICall from "../../../../../../shared/snackbar/SnackbarAPICall";
import { SnackbarProps } from "../../../../../../../@types/snackbarAPI.types";

import "../../../../../../../globalStyles/paperFormStyles.css";
import STATES from "../../../../../../../constants/states";
import CONTACT_LABELS from "../../../../../../../constants/contactLabels";
import validateEmail from "../../../../../../../utils/commonFunctions/validateEmail";
import { handleSSNFormat } from "../../../../../../../utils/commonFunctions/SSN";

const LightTooltip = withStyles((theme: Theme) => ({
	tooltip: {
		backgroundColor: "#f5f5f9",
		color: "rgba(0, 0, 0, 0.87)",
		boxShadow: theme.shadows[1],
		maxWidth: 130,
		fontSize: 11
	}
}))(Tooltip);

// Zip Handle Change left

const EditContactInformation = (): JSX.Element => {
	const querySSN = useRouteParam("qs");
	const queryGroupNumber = useRouteParam("gn");
	const [editContactForm, setEditContactForm] = useState<DynamicForm>();
	const [employee, setEmployee] = useState<any>({
		member_id: "",
		first_name: "",
		last_name: "",
		SSN: "",
		email: "",
		contact_label: "",
		phone_extension: "",
		phone_number: "",
		address_line_1: "",
		address_line_2: "",
		city: "",
		state: "",
		country: "USA - United States Of America",
		ZIP: ""
	});
	const { setDashboardHeader } = useContext(UIContext);
	const [employeeMongoID, setEmployeeMongoID] = useState<string>("");
	const [hasEditContactSubmitClick, setHasEditContactSubmitClick] = useState(false);
	const navigate = useNavigate();
	const [validation, setValidation] = useState<Validation>({
		employee: {},
		status: "invalid"
	});
	const _validation = useRef<Validation>();
	const routeParam = ExtractRouteParams(); // This is to extract the route after ?(Question Mark)
	const [pasted, setPasted] = useState(false);
	const [snackbarAPICallProps, setSnackbarAPICallProps] = useState<SnackbarProps>({
		open: false,
		severity: undefined,
		message: "",
		handleSnackbarClose: (event, reason) => {
			if (reason === "clickaway") return;
			setSnackbarAPICallProps(
				Object.assign({}, snackbarAPICallProps, {
					open: false
				})
			);
		}
	});
	const { user } = useContext(AuthContext);

	const handleValidation = useCallback(async () => {
		const { email, contact_label, address_line_1, city, state, country, ZIP, phone_extension, phone_number } =
			employee;
		_validation.current = {
			...validation,
			employee: {},
			status: "invalid"
		};
		let flag = true;

		// employee validation checking
		if (email && email.trim().length > 0) {
			if (!validateEmail(email)) {
				_validation.current.dependent["email"] = "Valid Email is required";
				flag = false;
			}
		}
		// if (email.length === 0) {
		// 	_validation.current.employee["email"] = "Email is required";
		// 	_validation.current["status"] = "invalid";
		// 	flag = false;
		// }
		// if (email.length !== 0) {
		// 	if (!validateEmail(email)) {
		// 		_validation.current.employee["email"] = "Valid Email is required";
		// 		_validation.current["status"] = "invalid";
		// 		flag = false;
		// 	}
		// }
		if (contact_label.length === 0) {
			_validation.current.employee["contact_label"] = "Contact Label is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (address_line_1.length === 0) {
			_validation.current.employee["address_line_1"] = "Address Line 1 is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (city.length === 0) {
			_validation.current.employee["city"] = "City is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (state.length === 0) {
			_validation.current.employee["state"] = "State is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (country.length === 0) {
			_validation.current.employee["country"] = "Country is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (phone_number === null) {
			_validation.current.employee["phone_number"] = "Phone number is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (phone_number !== null) {
			if (String(phone_number).length !== 10) {
				_validation.current.employee["phone_number"] = "Enter valid 10 digit phone number";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}
		// if (phone_extension === null) {
		// 	_validation.current.employee["phone_extension"] = "Phone extension is required";
		// 	_validation.current["status"] = "invalid";
		// 	flag = false;
		// }
		if (phone_extension !== null) {
			if (String(phone_extension).length > 3) {
				_validation.current.employee["phone_extension"] = "Enter Valid 3 digit Phone extension";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}
		if (ZIP.length === 0) {
			_validation.current.employee["ZIP"] = "ZIP Code is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (ZIP.length !== 0) {
			const _zip = ZIP.replaceAll("-", "");
			if (_zip.length !== 5 && _zip.length !== 9) {
				_validation.current.employee["ZIP"] = "Enter 5 or 9 digit ZIP Code!";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}

		if (flag === true) _validation.current["status"] = "valid";
		else {
			_validation.current["status"] = "invalid";
			alert("Please, fill all required fields!");
		}
		setValidation(Object.assign({}, _validation.current));
		return _validation.current["status"];
	}, [employee, validation]);

	const handleKeyCheck = useCallback(
		(event: React.KeyboardEvent<HTMLInputElement | HTMLDivElement>) => {
			let { value } = event.target as HTMLInputElement;
			const { name } = event.target as HTMLInputElement;
			const eventKey = event.key;

			// console.log("Key", eventKey);
			if (name === "ZIP") {
				if (eventKey === "Backspace" || eventKey === "Delete") {
					if (/[-]/.test(value) && value.length === 7) {
						// console.log("Value", value);
						const index = value.indexOf("-");
						// console.log("Index", index);
						value = value.substring(0, index);
						setEmployee(Object.assign({}, employee, { [name]: value }));
					} else {
						setEmployee(Object.assign({}, employee, { [name]: value }));
					}
				}
			}
		},
		[setEmployee, employee]
	);

	const handlePaste = (event: React.ClipboardEvent<HTMLInputElement | HTMLDivElement>) => {
		const { name } = event.target as HTMLInputElement;
		if (name === "SSN" || name === "ZIP" || name === "re_enter_SSN") {
			setPasted(true);
			setTimeout(() => null, 2000);
		}
	};

	const handleContactInformationChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { name } = event.target;
			let { value } = event.target;

			if (name === "phone_number") {
				if (!isNaN(value as any)) {
					if (value.length <= 10) {
						setEmployee(Object.assign({}, employee, { [name]: value }));
					} else {
						event.target.value = employee.phone_number ? (employee.phone_number as unknown as string) : "";
						alert("Phone Number cannot be greater 10 digit!");
					}
				} else {
					event.target.value = "";
					event.target.value = employee.phone_number ? (employee.phone_number as unknown as string) : "";
				}
			} else if (name === "phone_extension") {
				if (!isNaN(value as any)) {
					if (value.length <= 3) {
						setEmployee(Object.assign({}, employee, { [name]: value }));
					} else {
						event.target.value = employee.phone_extension
							? (employee.phone_extension as unknown as string)
							: "";
						alert("Phone Extension cannot be greater 3 digit!");
					}
				} else {
					event.target.value = "";
					event.target.value = employee.phone_extension
						? (employee.phone_extension as unknown as string)
						: "";
				}
			} else if (name === "ZIP") {
				if (!pasted) {
					// console.log("Inside ZIP");
					const _value = Number(value.replaceAll("-", ""));
					if (!isNaN(_value) && value.length <= 10) {
						const zip = value;
						if (zip.length === 6 && !zip.includes("-")) {
							value = value.substring(0, 5) + "-" + value.substring(5);
						}

						// console.log("ZIP Event", event.target.value);
						setEmployee(
							Object.assign({}, employee, {
								[name]: value
							})
						);
					} else {
						event.target.value = "";
						event.target.value = employee.ZIP;
					}
				} else {
					setPasted(false);
					if (!isNaN(value as any)) {
						if (value.length > 9) {
							event.target.value = "";
							event.target.value = employee.ZIP;
							alert("Please enter a valid 5 or 9 digit ZIP!");
						} else {
							// console.log("Inside Number");
							const zip = value;

							if (zip.length >= 6 && zip.length <= 9) {
								value = value.substring(0, 5) + "-" + value.substring(5);
							}

							setEmployee(Object.assign({}, employee, { [name]: value }));
						}
					} else {
						// console.log("Inside alpha-numeric");
						let zipValue = value.replace(/[^0-9]/g, "").replace(/[^\w\s]/gi, "");
						//console.log("replaced string", zipValue);
						alert("You have pasted alpha-numeric ZIP!");

						if (zipValue.length > 9) {
							event.target.value = "";
							event.target.value = employee.ZIP;
							alert("Please enter a valid 5 or 9 digit ZIP!");
						} else {
							const zip = zipValue;

							if (zip.length >= 6 && zip.length <= 9) {
								zipValue = zipValue.substring(0, 5) + "-" + zipValue.substring(5);
							}

							setEmployee(Object.assign({}, employee, { [name]: zipValue }));
						}
					}
				}
			} else {
				setEmployee(Object.assign({}, employee, { [name]: value }));
			}
		},
		[employee, pasted]
	);

	// console.log("Employee", employee);

	const getMembersByEmployeeSSN = useCallback(async (_employee_SSN: string, group_number: number) => {
		const findEmployeeQuery = {
			group_number,
			employee_SSN: _employee_SSN
		};

		const response = await trackPromise(api.member.getMembersByEmployeeSSN(findEmployeeQuery));
		// console.log("Members: ", members);
		if (response) {
			// console.log("Members: ", members);
			const { memberInstance } = response;
			memberInstance.forEach(async (member: MemberTypes) => {
				const { role } = member;
				if (role === ROLES.employee) {
					const {
						_id,
						member_id,
						first_name,
						last_name,
						email,
						SSN,
						contact_label,
						address_line_1,
						address_line_2,
						city,
						state,
						country,
						ZIP,
						phone_extension,
						phone_number
					} = member;

					setEmployeeMongoID(_id as string);

					// Converting ZIP into required format
					let _ZIP = String(ZIP);
					if (_ZIP.length > 5) _ZIP = ZIP?.substring(0, 5) + "-" + ZIP?.substring(5);

					const _member = {
						member_id,
						first_name,
						last_name,
						email,
						SSN,
						contact_label,
						address_line_1,
						address_line_2,
						city,
						state,
						country,
						ZIP: _ZIP,
						phone_extension,
						phone_number
					};
					setEmployee(Object.assign({}, _member));
				}
			});
		}
	}, []);

	const handleRedirectToMemberDetails = useCallback(() => {
		const pathname = `/employer/member?${routeParam}`;
		navigate(pathname);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleHyphenInZip = (event: KeyboardEvent<HTMLInputElement>) => {
		if (event.key === "-") {
			event.preventDefault();
		}
	};

	const handleEditContactSubmitClick = useCallback(
		async (event: React.MouseEvent<HTMLButtonElement>) => {
			try {
				event.preventDefault();
				const validation = await handleValidation();
				if (validation === "valid") {
					const { ZIP } = employee;
					const payload: MemberTypes = {
						...employee,
						ZIP: ZIP !== "" || ZIP !== null || ZIP !== undefined ? ZIP?.replaceAll("-", "") : ""
					};

					// console.log("Payload", payload);
					const response: MemberTypes = await trackPromise(
						api.member.editContactInformationById(payload, employeeMongoID as string)
					);

					if (response) {
						setHasEditContactSubmitClick(true);
						// console.log("Response", response);

						// alert("Edit Contact Information Submission Successfully!");
						setSnackbarAPICallProps(
							Object.assign({}, snackbarAPICallProps, {
								open: true,
								message: "Edit Contact Information Submission Successfully!",
								severity: "success"
							})
						);

						setTimeout(() => {
							handleRedirectToMemberDetails();
						}, 2000);
					}
				} else {
					setHasEditContactSubmitClick(false);
				}
			} catch (error) {
				setHasEditContactSubmitClick(false);
				alert("Edit Contact Information submission unsuccessful!");
				throw error;
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[employee, handleValidation]
	);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.edit_contact);
	}, [setDashboardHeader]);

	useEffect(() => {
		if (querySSN && queryGroupNumber) getMembersByEmployeeSSN(querySSN as string, queryGroupNumber as number);
	}, [getMembersByEmployeeSSN, queryGroupNumber, querySSN]);

	useEffect(() => {
		setEditContactForm(
			Object.assign(
				{},
				{
					"Contact Information": [
						{
							label: "Employee Id",
							name: "member_id",
							onChange: () => null,
							value: employee.member_id,
							type: "textfield"
						},
						{
							label: "First Name",
							name: "first_name",
							value: employee.first_name,
							onChange: () => null,
							type: "textfield"
						},
						{
							label: "Last Name",
							name: "last_name",
							value: employee.last_name,
							onChange: () => null,
							type: "textfield"
						},

						{
							label: "SSN",
							name: "SSN",
							onChange: () => null,
							value: handleSSNFormat(user, employee.SSN),
							type: "textfield"
						},
						{
							label: "Email",
							name: "email",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleContactInformationChange(event),
							value: employee.email,
							type: "textfield"
						},
						{
							label: "Contact Label",
							name: "contact_label",
							value: employee.contact_label,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleContactInformationChange(event),
							type: "select",
							options: CONTACT_LABELS
						},
						{
							label: "Phone Number",
							name: "phone_number",
							value: employee.phone_number,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleContactInformationChange(event),
							type: "textfield"
						},
						{
							label: "Phone Extension",
							name: "phone_extension",
							value: employee.phone_extension,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleContactInformationChange(event),
							type: "textfield"
						},
						{
							label: "Address Line 1",
							name: "address_line_1",
							value: employee.address_line_1,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleContactInformationChange(event),
							type: "textfield"
						},
						{
							label: "Address Line 2",
							name: "address_line_2",
							value: employee.address_line_2,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleContactInformationChange(event),
							type: "textfield"
						},
						{
							label: "City",
							name: "city",
							value: employee.city,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleContactInformationChange(event),
							type: "textfield"
						},
						{
							label: "State",
							name: "state",
							value: employee.state,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleContactInformationChange(event),
							type: "select",
							options: STATES
						},
						{
							label: "Country",
							name: "country",
							value: employee.country,
							onChange: () => null,
							type: "textfield"
						},
						{
							label: "ZIP Code",
							name: "ZIP",
							value: employee.ZIP,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleContactInformationChange(event),
							type: "textfield"
						}
					]
				}
			)
		);
	}, [employee, handleContactInformationChange, user]);

	// console.log("Employee", employee);
	// console.log("EmployeeMongoID", employeeMongoID);

	return (
		<div className="edit-profile-information-container">
			<Suspense fallback={<div />}>
				<SnackbarAPICall snackbarProps={snackbarAPICallProps} />
			</Suspense>
			<div className="pf-action-button-container" id="pf-action-button-container">
				<Button
					className="button-green"
					onClick={handleEditContactSubmitClick}
					variant="contained"
					disabled={hasEditContactSubmitClick}
					style={{
						cursor: hasEditContactSubmitClick ? "not-allowed" : "pointer",
						pointerEvents: "unset"
					}}
				>
					<span className="button-label-with-icon">Submit</span>
					<span>
						<SendIcon className="button-icon" />
					</span>
				</Button>
			</div>
			<Grid container spacing={1} className="pf-grid-container">
				{editContactForm &&
					Object.entries(editContactForm).map(([key, value], index) => {
						return (
							<div key={index}>
								<div className="pf-title">{key}</div>
								<Paper className="pf-paper-container" variant="outlined" elevation={3}>
									{value.map((field, index) => {
										const { name, label, value, type, onChange } = field;
										return (
											<Grid item key={index} xl={12} lg={12} md={12} sm={12} xs={12}>
												<Grid container spacing={1} className="pf-label">
													<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
														<div className="pf-label-text" id="pf-label-text">
															{label}
														</div>
													</Grid>
													<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
														{type === "textfield" ? (
															<TextField
																className="input-text-field"
																id={
																	name === "member_id" ||
																	name === "first_name" ||
																	name === "last_name" ||
																	// name === "email" ||
																	name === "SSN" ||
																	name === "country"
																		? "disabled-input-text-field"
																		: "input-text-field"
																}
																value={
																	name === "contact_label"
																		? initCapitalize(value)
																		: value
																}
																name={name}
																onChange={onChange}
																onKeyDown={(
																	event: React.KeyboardEvent<HTMLDivElement>
																) => handleKeyCheck(event)}
																onPaste={(
																	event: React.ClipboardEvent<HTMLDivElement>
																) => handlePaste(event)}
																variant="outlined"
																disabled={
																	name === "member_id" ||
																	name === "first_name" ||
																	name === "last_name" ||
																	// name === "email" ||
																	name === "SSN" ||
																	name === "country"
																		? true
																		: false
																}
																inputProps={{
																	onKeyDown:
																		name === "ZIP" ? handleHyphenInZip : undefined
																}}
																InputProps={{
																	endAdornment: (
																		<>
																			{name === "member_id" ||
																			name === "first_name" ||
																			name === "last_name" ||
																			// name === "email" ||
																			name === "SSN" ||
																			name === "country" ? (
																				<InputAdornment position="end">
																					<LightTooltip
																						title={
																							name === "member_id"
																								? infoTitleMessage.member_id
																								: // : name === "email"
																								// ? infoTitleMessage.email
																								name === "SSN"
																								? infoTitleMessage.SSN
																								: name === "first_name"
																								? infoTitleMessage.first_name
																								: name === "last_name"
																								? infoTitleMessage.last_name
																								: name === "country"
																								? infoTitleMessage.country
																								: ""
																						}
																						placement="right-start"
																						arrow
																					>
																						<InfoIcon
																							style={{
																								color: "#808080",
																								fontSize: "20px",
																								// cursor: !showSaveButton
																								// 	? "default"
																								// 	: "pointer",
																								pointerEvents: "unset"
																							}}
																						/>
																					</LightTooltip>
																				</InputAdornment>
																			) : null}
																		</>
																	),
																	readOnly:
																		name === "member_id" ||
																		name === "first_name" ||
																		name === "last_name" ||
																		// name === "email" ||
																		name === "SSN" ||
																		name === "country"
																			? true
																			: false
																}}
																helperText={validation.employee[name]}
																style={{
																	pointerEvents: "unset",
																	width: "340px",
																	borderRadius: 50
																}}
															/>
														) : type === "select" ? (
															<>
																<Select
																	id="text-align-options"
																	name={name}
																	value={value}
																	onChange={onChange}
																	style={{
																		pointerEvents: "unset",
																		minWidth: 180,
																		textAlign: "left",
																		overflowY: "visible"
																	}}
																	MenuProps={{
																		style: { zIndex: 35960 }
																	}}
																	inputProps={{ "aria-label": "Without label" }}
																>
																	<MenuItem value="" disabled>
																		Select Value
																	</MenuItem>
																	{field?.options?.map((option) => {
																		return (
																			<MenuItem key={option} value={option}>
																				{name !== "state"
																					? initCapitalize(option as string)
																					: option}
																			</MenuItem>
																		);
																	})}
																</Select>
																{validation && validation.employee[name] ? (
																	<div className="details">
																		<span className="select-validation-text2">
																			{validation.employee[name]}
																		</span>
																	</div>
																) : null}
															</>
														) : type === "date" ? (
															<MuiPickersUtilsProvider utils={DateFnsUtils}>
																<KeyboardDatePicker
																	className="from-date-input"
																	id="from-date-input"
																	inputVariant="outlined"
																	label={label}
																	name={name}
																	format="MM/dd/yyyy"
																	error={false}
																	value={value}
																	onChange={(date: MaterialUiPickersDate) =>
																		onChange(date, name)
																	}
																	InputProps={{
																		readOnly: true
																	}}
																	InputLabelProps={{
																		shrink: true
																	}}
																	keyboardIcon={
																		<EventIcon
																			style={{
																				color: "#7cb342"
																			}}
																		/>
																	}
																	KeyboardButtonProps={{
																		"aria-label": "change date"
																	}}
																	style={{
																		pointerEvents: "unset",
																		width: "340px",
																		borderRadius: 50
																	}}
																	helperText={validation.employee[name]}
																/>
															</MuiPickersUtilsProvider>
														) : null}
													</Grid>
												</Grid>
											</Grid>
										);
									})}
								</Paper>
							</div>
						);
					})}
			</Grid>
			<div className="pf-action-button-container margin-top-action-button" id="pf-action-button-container">
				<Button
					className="button-green"
					onClick={handleEditContactSubmitClick}
					variant="contained"
					disabled={hasEditContactSubmitClick}
					style={{
						cursor: hasEditContactSubmitClick ? "not-allowed" : "pointer",
						pointerEvents: "unset"
					}}
				>
					<span className="button-label-with-icon">Submit</span>
					<span>
						<SendIcon className="button-icon" />
					</span>
				</Button>
			</div>
		</div>
	);
};

export default EditContactInformation;
